import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import { ProductCard } from "./Shop";
import { FiArrowRight } from "react-icons/fi";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <main>
        <section className="hero">
          <img src="/img/home/hero.png" alt="Bentomarket home and kitchen collection" />
          <div className="hero-copy">
            <p>JUST LANDED</p>
            <h1>Find your<br />everyday essential</h1>
            <Link to="/shop" onClick={toTop}>Shop new arrivals <FiArrowRight /></Link>
          </div>
        </section>

        <section className="home-products page-shell">
          <div className="section-heading"><h2>New Cuties</h2><Link to="/shop" onClick={toTop}>View all <FiArrowRight /></Link></div>
          <div className="home-product-row">{productData.slice(0, 8).map((product) => <ProductCard product={product} key={product.id} />)}</div>
        </section>

        <section className="category-section">
          <div className="section-heading page-shell"><h2>Browse the collection</h2></div>
          <div className="category-grid page-shell">
            {[
              ["Kitchen essentials", "/img/home/washi.jpg", "ceramic"],
              ["Organised living", "/img/home/cards.jpg", "organizer"],
              ["Workspace comfort", "/img/home/notebooks.jpg", "desk"],
              ["Thoughtful home details", "/img/home/stickers.jpg", "home"],
            ].map(([title, image, search]) => <Link key={title} to={`/shop?search=${search}`} onClick={toTop}><img src={image} alt="" loading="lazy" /><h3>{title}</h3></Link>)}
          </div>
        </section>

        <section className="favorites-section page-shell">
          <div className="section-heading"><div><p>customer favorites</p><h2>bentomarket best sellers</h2></div><Link to="/shop" onClick={toTop}>View all <FiArrowRight /></Link></div>
          <div className="home-product-row">{productData.slice(9, 17).map((product) => <ProductCard product={product} key={product.id} />)}</div>
        </section>

        <section className="more-love page-shell">
          <h2>more to love ✨</h2>
          <div className="more-love-grid">
            <Link to="/shop?category=Accessories" onClick={toTop} className="love-image"><img src="/img/home/strawberry.jpg" alt="Canvas tote and useful everyday accessories" loading="lazy" /><span>everyday accessories <FiArrowRight /></span></Link>
            <div className="love-event"><p>MAKE HOME FEEL EASY</p><h3>Simple essentials, thoughtfully selected</h3><p>Practical pieces for organised kitchens, calm workspaces and comfortable rooms.</p><Link to="/shop?category=Home%20Accents" onClick={toTop}>Explore home <FiArrowRight /></Link></div>
          </div>
        </section>

        <section className="visit-shop">
          <img src="/img/home/shop.jpg" alt="Bentomarket home collection in a Hong Kong interior" loading="lazy" />
          <div><p>OUR STORY</p><h2>EVERYDAY GOODS, SELECTED IN HONG KONG</h2><p>Bentomarket brings useful, well-made pieces together for simpler daily routines.</p><Link to="/about" onClick={toTop}>Learn more <FiArrowRight /></Link></div>
        </section>
      </main>
    </div>
  );
}

export default Main;
